import { render, staticRenderFns } from "./NavigationLinkForm.vue?vue&type=template&id=879a25e4&scoped=true&"
import script from "./NavigationLinkForm.vue?vue&type=script&lang=js&"
export * from "./NavigationLinkForm.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLinkForm.vue?vue&type=style&index=0&id=879a25e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a25e4",
  null
  
)

export default component.exports